import { RiskScoreLevelEnum, type RiskType } from "@/config";

export const getRiskTypeByLevel = (
  level: RiskScoreLevelEnum,
): RiskType => {
  switch (level) {
    case RiskScoreLevelEnum.LOW:
      return "trusted";
    case RiskScoreLevelEnum.MEDIUM:
      return "suspicious";
    case RiskScoreLevelEnum.HIGH:
      return "danger";
    default:
      return "unknown";
  }
};